module.exports = __webpack_public_path__ + "img/card3.5f1b930b.png";